import _default from './Modal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Modal/index.js
// module id = 730
// module chunks = 0